export default __webpack_public_path__ + "static/media/folder-blue.d1b90815.svg";